<div class="grid-6 copo-container footer-margin" *ngIf="segment && segment.bakeHardeningList && this.segment.bakeHardeningList.length > 0">
	<div class="grid-column-one-full">
		<mat-expansion-panel [expanded]="true" class="card-info-block">
			<mat-expansion-panel-header>
				<mat-panel-title class="card-content-title">
					<span translate>aqdb.mechanical.characteristics.bake.hardening</span>
				</mat-panel-title>
			</mat-expansion-panel-header>
			<mat-divider class="margin-expansion-panel"></mat-divider>
			<div class="card-content-block quadruple-column" *ngFor="let bakeHardening of segment.bakeHardeningList">
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.test.number.bakehardening</div>
						<div class="card-content-value">{{ bakeHardening.testNumber ? (bakeHardening.testNumber | copoNumber:'number') : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.pos.across.width</div>
						<div class="card-content-value"> 
							<div *ngIf="bakeHardening.samplePositionAcrossWidthCode === 'A'">
								<span translate>aqdb.axis</span>
							</div>
							<div *ngIf="bakeHardening.samplePositionAcrossWidthCode === 'Q'">
								<span translate>aqdb.quarter</span>
							</div>
							<div *ngIf="bakeHardening.samplePositionAcrossWidthCode !== 'A' && bakeHardening.samplePositionAcrossWidthCode !== 'Q'">
								{{ UNDERSCORE }}
							</div>
						</div>
					</div>
				</div>
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.pos.across.length</div>
						<div class="card-content-value">{{ bakeHardening.samplePositionAlongLength !== null && bakeHardening.samplePositionAlongLength !== undefined ? (bakeHardening.samplePositionAlongLength | copoNumber:'weight') : UNDERSCORE }} </div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.anisotropy.direction</div>
						<div *ngIf="bakeHardening.sampleDirectionCode === 'T'">
							<span translate>aqdb.direction.T</span>
						</div>
						<div *ngIf="bakeHardening.sampleDirectionCode === 'L'">
							<span translate>aqdb.direction.L</span>
						</div>
						<div *ngIf="bakeHardening.sampleDirectionCode !== 'T' && bakeHardening.sampleDirectionCode !== 'L'">
							{{ UNDERSCORE }}
						</div>
					</div>
				</div>
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.bakeHardening.without.elongation</div>
						<div class="card-content-value">{{ bakeHardening.valueBH0 !== null && bakeHardening.valueBH0 !== undefined && isDisplayedData(bakeHardening.indTrsBH0) ? (bakeHardening.valueBH0 | copoNumber:'weight') : UNDERSCORE }}
							<span *ngIf="isTransmittedOnCertificateData(bakeHardening.indTrsBH0)" class="transmitted-data-icon"><mat-icon [matTooltip]="'aqdb.datas.transmitted.on.certificate' | translate" color="accent" class="batch-icon" svgIcon="icon-transmitted"></mat-icon></span>
							<span *ngIf="isMeasuredData(bakeHardening.indTrsBH0, bakeHardening.valueBH0Typdon)"><mat-icon [matTooltip]="'aqdb.measured.datas' | translate" color="accent" class="batch-icon" svgIcon="icon-measured"></mat-icon></span>
							<span *ngIf="isModelledData(bakeHardening.indTrsBH0, bakeHardening.valueBH0Typdon)"><mat-icon  [matTooltip]="'aqdb.modelled.data' | translate" color="accent" class="batch-icon" svgIcon="icon-modelled"></mat-icon></span>
						</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.bakeHardening.with.elongation</div>
						<div class="card-content-value">{{ bakeHardening.valueBH2 !== null && bakeHardening.valueBH2 !== undefined && isDisplayedData(bakeHardening.indTrsBH2) ? (bakeHardening.valueBH2 | copoNumber:'weight') : UNDERSCORE }}
							<span *ngIf="isTransmittedOnCertificateData(bakeHardening.indTrsBH2)" class="transmitted-data-icon"><mat-icon [matTooltip]="'aqdb.datas.transmitted.on.certificate' | translate" color="accent" class="batch-icon" svgIcon="icon-transmitted"></mat-icon></span>
							<span *ngIf="isMeasuredData(bakeHardening.indTrsBH2, bakeHardening.valueBH2Typdon)"><mat-icon [matTooltip]="'aqdb.measured.datas' | translate" color="accent" class="batch-icon" svgIcon="icon-measured"></mat-icon></span>
							<span *ngIf="isModelledData(bakeHardening.indTrsBH2, bakeHardening.valueBH2Typdon)"><mat-icon  [matTooltip]="'aqdb.modelled.data' | translate" color="accent" class="batch-icon" svgIcon="icon-modelled"></mat-icon></span>
						</div>
					</div>
				</div>
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.steel.condition</div>
						<div class="card-content-value">{{ bakeHardening.testSteelCondition ? bakeHardening.testSteelCondition : UNDERSCORE }}</div>
					</div>
				</div>
			</div>
		</mat-expansion-panel>
	</div>
</div>
